import React, { Component, Fragment, useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import ConfiguratorOptions from '../ConfiguratorOptions';
import ConfiguratorOptionInfo from '../ConfiguratorOptionInfo';
import Checkbox from '../Checkbox';
import QuantitySelector from '../QuantitySelector';
import BuyBox from './BuyBox';
import LightboxImagesAccessories from '../LightboxImagesAccessories';
import ConfiguratorBuySamples from '../ConfiguratorBuySamples';
import { string, object } from 'yup';
import ProductPrice from '../ProductPrice';
import { culture } from '../../Services/culture';
import { currency } from '../../Services/currency';
import { pushAddToCartEvent } from '../../Actions/Gtm.action';
import { load as loadCart, hint as hintCart } from '../../Actions/Cart.action';
import { useDispatch, useSelector } from 'react-redux';
import { selectSuperBuilderVariant } from '../../Actions/SuperBuilder.action';


const Configurator = (props) => {
    const dispatch = useDispatch();
    const superBuilder = useSelector((state) => state.superBuilder);
    const [activeAccessory, setactiveAccessory] = useState(null);
    const [stockstatus, setstockstatus] = useState([]);
    const [allCustomOptions, setallCustomOptions] = useState([]);
    const [buySampleAllCustomOptions, setbuySampleAllCustomOptions] = useState([]);
    const [data, setdata] = useState([]);
    const [selectedOptions, setselectedOptions] = useState(null);
    const [sectionsSelected, setsectionsSelected] = useState(false);
    const [accessorySelected, setaccessorySelected] = useState(false);
    const [totalsData, settotalsData] = useState([]);
    const [infoArticle, setinfoArticle] = useState(null);
    const [infoSection, setinfoSection] = useState(null);
    const [showOptionsData, setshowOptionsData] = useState(false);
    const [showData, setshowData] = useState(false);
    const [showBuySample, setshowBuySample] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [buySampleViewAll, setbuySampleViewAll] = useState(false);
    const [buySampleErrorFields, setbuySampleErrorFields] = useState([]);
    const [showError, setshowError] = useState("");
    const [buySampleList, setbuySampleList] = useState([]);
    const [buySampleData, setbuySampleData] = useState({Name: "", Email: "", Address: "", PostNumber: "", Region: "", Telephone: "" });
    const [fabricCollectionViewAll, setfabricCollectionViewAll] = useState([]);
    const [showBuySamplesFabricCollectionItems, setshowBuySamplesFabricCollectionItems] = useState([]);
    const [prices, setprices] = useState([]);
    const [totals, settotals] = useState();
    const [grandTotal, setgrandTotal] = useState(0);
    const [originalTotal, setoriginalTotal] = useState(0);
    const [configuratorTotal, setconfiguratorTotal] = useState(0);
    const [originalPrice, setoriginalPrice] = useState(0);
    const [showMoreButton, setshowMoreButton] = useState(false);
    const [loadConfiguratorOptions, setloadConfiguratorOptions] = useState(false);
    const [firstTimeLoad, setfirstTimeLoad] = useState(true);    
    const [quantity, setquantity] = useState();
    const [updateBuySamples, setupdateBuySamples] = useState(false);


    const formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
        const maximumNumberOfItemsInCollection = 50;
        const maximumNumberOfItemsInSection = 8;                
                                             


    useEffect(() => {
        if (totals) {
            setgrandTotal(totals.grandTotal);
            setoriginalTotal(totals.originalTotal);
            setconfiguratorTotal(totals.configuratorTotal);
            setoriginalPrice(totals.originalPrice);
        }        
    }, [totals]);

    useEffect(() => {
        if (data && data.sections) {
            setshowMoreButton(data.sections.filter((x) => !x.isAccessory).length > 1);
            refreshSelection();
            data.sections.forEach(section => {
                toggleFabricCollectionSectionVisibility(section.options.filter(o => o.fabricCollectionName != ""))
                toggleBuySampleFabricCollectionVisibility(section.options.filter(o => o.fabricCollectionName != ""))
            });
            settotals(getGrandTotal());
        }        
    }, [data, data.sections]);
    
    useEffect(() => {        
       setstockstatus(JSON.parse(props.stockstatus));       

        var configData = JSON.parse(props.configurator);
        var pricesData = JSON.parse(props.prices);

        let selectedOptionsName = props.selectedOptions != null ? props.selectedOptions : selectedOptions;
        let sectionsSelectedTemp = props.sectionsSelected != null ? props.sectionsSelected : sectionsSelected;
        if (configData.changeVariant) {
            selectedOptionsName = getSelectedOptions(configData, configData.changeVariant);
            sectionsSelectedTemp = setAllSectionsNonSelected(configData);
        }

        setprices(pricesData);

        var tempConfigData = data;
        tempConfigData.selectedCombinedKeys = configData.selectedCombinedKeys;
        setdata(tempConfigData);
              
        setstockstatus(JSON.parse(props.stockstatus)); 
        setaccessorySelected(false);
        setselectedOptions(selectedOptionsName);
        setsectionsSelected(sectionsSelectedTemp);        
        refreshPrice(configData, pricesData);

        var allCustomOptionsTemp = allCustomOptions;
        configData.sections.forEach(s => s.options.forEach((o) => {
            if (o.custom) {
                allCustomOptionsTemp.push({
                    optionId: o.optionId,
                    sectionname: s.name,
                    textvalue: "",
                    selected: false
                })
            }

        }));
        setallCustomOptions(allCustomOptionsTemp);   
        
        stickyBuyboxObserver();                
        if (props) {
            setstockstatus(JSON.parse(props.stockstatus));
        }        

    }, [props.configurator, props.prices]);

    useEffect(() => {        
        var configData = JSON.parse(props.configurator);
        setdata(configData);     
        setquantity(props.packagingQuantity);
    }, []);

    useEffect(() => {
        if (data && data.sections) {
            let totals = getGrandTotal();
            setgrandTotal(totals.grandTotal);
            setoriginalTotal(totals.originalTotal);
            setconfiguratorTotal(totals.configTotal);
        }        
    }, [quantity]);
    

    const stickyBuyboxObserver = () => {
        if (!!window.IntersectionObserver) {
            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    var buyContainer = document.getElementsByClassName("buy-box__main");
                    if (buyContainer.length) {
                        if (entry.boundingClientRect.bottom < entry.rootBounds.bottom) {
                            buyContainer[0].classList.add("anim-hide");
                        } else {
                            buyContainer[0].classList.remove("anim-hide");
                        }
                    }
                });
            }, {
                rootMargin: "100% 0px 0px 0px",
                threshold: 1
            }
            );
            document.querySelectorAll('.js-product-info').forEach(item => { observer.observe(item) });
        }
    }

    const getGrandTotal = () => {
        let totalPrices = getPriceFromKey(data.selectedCombinedKeys);
        let totals = {
            grandTotal: totalPrices.price * quantity,
            originalTotal: totalPrices.originalPrice * quantity,
            configTotal: totalPrices.price
        }

        data.sections.forEach(section => {
            if (section.isAccessory) {
                section.options.forEach(o => {
                    if (o.selected) {
                        let unitPrice = (o.campaignPrice > 0 && o.campaignPrice < o.price ? o.campaignPrice : o.price);
                        totals.grandTotal += (unitPrice * o.quantity);
                        totals.originalTotal += (o.price * o.quantity);
                    }
                });
            }
        });

        return totals;
    }

    const onAccessoryClick = (item) => {
        setactiveAccessory(item);        
    }

    const getStockStatus = () => {
        fetch("/api/productConfigurator/getstockstatus", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify({
                "Model": data
            }),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                if (result)
                setstockstatus(result);                    
            })
            .catch(error => console.log('error', error));
    }


    const getPriceChange = (key, section) => {
        let replaceKey = '',
            tempCombindKeys = [...data.selectedCombinedKeys];

        if (tempCombindKeys.length > 0) {

            replaceKey = getSelectedOrDefaultOptionKeyFromSection(section);

            if (replaceKey == key) {
                return 0;
            }

            tempCombindKeys = replaceOrAddConfigKey(key, replaceKey, true);
            var tempCombinedKeyPrice = getPriceFromKey(tempCombindKeys).price;
            var originalKeyprice = getPriceFromKey(data.selectedCombinedKeys).price;

            if (tempCombinedKeyPrice === 0 && tempCombindKeys[0].value !== undefined) {                
                var currentTempCombinedKey = tempCombindKeys;
                currentTempCombinedKey[0].value = currentTempCombinedKey[0].value.splice(0, currentTempCombinedKey[0].value.length - 1)
                var tempCombinedKeyPrice = getPriceFromKey(currentTempCombinedKey).price;
            }

            return (tempCombinedKeyPrice - originalKeyprice);
        }

        return 0;
    }

    const replaceOrAddConfigKey = (key, oldKey, temp) => {
        if (key == oldKey) {
            return [...data.selectedCombinedKeys];
        }        

        let tempCombindKeys = [];
        if (temp) {
            for (var i = 0; i < data.selectedCombinedKeys.length; i++) {
                let tempValue = [];
                for (var u = 0; u < data.selectedCombinedKeys[i].value.length; u++) {
                    tempValue.push(data.selectedCombinedKeys[i].value[u]);
                }
                tempCombindKeys.push({ key: data.selectedCombinedKeys[i].key, value: tempValue, 
                    added: data.selectedCombinedKeys[i].added, 
                    quantity: data.selectedCombinedKeys[i].quantity,
                    isMaximumOfOneAllowed: data.selectedCombinedKeys[i].isMaximumOfOneAllowed });
            }
        }
        else {
            tempCombindKeys = [...data.selectedCombinedKeys];
        }

        tempCombindKeys.forEach((selectedKeys) => {
            var oldSelectedKeyIndex = selectedKeys.value.findIndex(v => v === oldKey);
            var newKeyAlreadyExistsIndex = selectedKeys.value.findIndex(v => v === key);

            if (oldSelectedKeyIndex != -1) {
                selectedKeys.value[oldSelectedKeyIndex] = key;
            }
            else if (newKeyAlreadyExistsIndex == -1) {
                if (!selectedKeys.value.includes(key)) {
                    selectedKeys.value.push(key);
                }
            }
        });

        return tempCombindKeys;
    }

    const getConfiguratorArticleNumber = (keys, isSuperBuilder = false) => {
        let articleNumber = '';

        for (let i = 0; i < prices.length; i++) {
            let price = prices[i],
                test = { key: "", value: [], added: false, quantity: 0 },
                priceNotMatched = true;

            for (let y = 0; y < keys.length; y++) {
                priceNotMatched = true;
                if (!keys[y].added) {
                    priceNotMatched = true;
                    for (let u = 0; u < keys[y].value.length; u++) {
                        priceNotMatched = isSuperBuilder ? !(price.systemKeys.includes(keys[y].key) && price.systemKeys.includes(keys[y].value[u])) 
                        : !price.systemKeys.includes(keys[y].value[u]);
                        if (priceNotMatched) {
                            break;
                        }
                    }
                    if (!priceNotMatched) {
                        test = keys[y];
                        break;
                    }
                }
            }

            if (test.value.length > 0) {
                articleNumber = price.articleNumber;
                if (articleNumber !== undefined) {
                    test.added = true;
                    articleNumber = price.articleNumber;
                    break;
                }
            }
        }

        resetAdded(keys);

        return articleNumber;
    }

    const getPriceFromKey = (keys) => {        
        let prices = {
            price: 0,
            originalPrice: 0,
            grandTotal: 0
        };

        var isSuperBuilderActiveAndSelected = props && props.isSuperBuilderActive ? superBuilder.selectedCombinedSuperBuilderKeys != undefined 
        && superBuilder.selectedCombinedSuperBuilderKeys.length > 0 : true;
        if (keys && keys == 0 || !isSuperBuilderActiveAndSelected) 
            return prices;
        // if (keys && keys.length == 0) {

        //     if (isSuperBuilderActiveAndSelected) {
        //         return getTotalPriceFromKeys(superBuilder.selectedCombinedSuperBuilderKeys);
        //     } else {
        //         return prices;
        //     }            
        // }

        prices = getTotalPriceFromKeys(keys);
        
        return prices;
    }

    const getOptionsCssClass = () => {
        return 'configurator-options' + (showOptionsData ? ' configurator-options--show-options' : '') + (infoArticle ? ' configurator-options--show-option-info' : '');
    }

    const buy = () => {
        let order = {
            parentid: props.parent.systemId,
            articles: [],
            rowItems: [],
            isSuperBuilder: false,            
        }        

        if (props.isSuperBuilderActive) {
            order.isSuperBuilder = true;
            let selectedCombinedKeys = superBuilder.selectedCombinedSuperBuilderKeys;
            for (var i = 0; i < selectedCombinedKeys.length; i++) {
                const combinedArticleNumber = getConfiguratorArticleNumber([selectedCombinedKeys[i]], true);
                order.articles.push({
                    articleNumber: combinedArticleNumber,
                    quantity: selectedCombinedKeys[i].quantity * quantity,
                    isAccessory: false,
                    superBuilderKey: selectedCombinedKeys[i].key,
                    isMandatory: selectedCombinedKeys[i].isMandatory,
                    isMaximumOfOneAllowed: selectedCombinedKeys[i].isMaximumOfOneAllowed,
                    article: combinedArticleNumber
                });
            }
        }
        else {
            const combinedArticleNumber = getConfiguratorArticleNumber(data.selectedCombinedKeys, false);
            order.articles.push({
                articleNumber: combinedArticleNumber,
                quantity: quantity,
                isAccessory: false,
                superBuilderKey: "",
                article: combinedArticleNumber,
            });
        }

        data.sections.forEach(s => s.options.forEach((o) => {
            if (o.selected) {
                if (s.isAccessory) {
                    order.articles.push({
                        articleNumber: o.articleNumber,
                        quantity: o.quantity,
                        isAccessory: true,
                        superBuilderKey: ""
                    });
                } else {
                    let rowItem = {
                        articleNumber: o.articleNumber,
                        name: o.name,
                        collectionName: o.fabricCollectionName
                    };

                    if (o.additionalInfo) {
                        rowItem.additionalInfo = {
                            row1: o.additionalInfo.row1,
                            row2: o.additionalInfo.row2,
                        }
                    }

                    order.rowItems.push(rowItem);
                }
            }
        }));

        // Add to cart
        fetch("/api/cart/addconfiguredarticle", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify(order),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart(result)).then(() => {
                    if (order.articles[0]) {
                        dispatch(hintCart(true, order.articles[0].articleNumber))
                        setTimeout(() => {
                            dispatch(hintCart(false, order.articles[0].articleNumber))
                        }, 2000);                    
                        dispatch(pushAddToCartEvent(order.articles, false));
                    }
                });                                
            })
            .catch(error => console.log('error', error));
    }

    const scrollToSuperBuilder = () => {
        if (data.nonMandatorySectionNotSelectedId && data.nonMandatorySectionNotSelectedId != "") {
            const violation = document.getElementById(data.nonMandatorySectionNotSelectedId);
            if (violation != undefined) {
                const position = (violation.offsetTop - 120);
                window.scrollTo({
                    top: position,
                    behavior: "smooth"
                });
            }
        }
    }

    const getSectionFromOption = (option) => {
        let section = null;

        data.sections.forEach(s => s.options.forEach((o) => {
            if (o.articleNumber === option.articleNumber) {
                section = s;
            }
        }));

        return section;
    }

    const ExpandOptionsValidationInit = () => {
        var allCustomOptionsTemp = allCustomOptions;
        if (allCustomOptionsTemp != undefined && allCustomOptionsTemp.length > 0) return;

        data.sections.forEach(s => s.options.forEach((o) => {
            if (o.custom) {
                allCustomOptionsTemp.push({
                    optionId: o.optionId,
                    sectionname: s.name,
                    textvalue: "",
                    selected: false
                })
            }

        }));
        setallCustomOptions(allCustomOptionsTemp);        
    }

    const BuySamplesExpandOptionsValidationInit = () => {
        var buySampleAllCustomOptionsTemp = buySampleAllCustomOptions;
        if (buySampleAllCustomOptionsTemp != undefined && buySampleAllCustomOptionsTemp.length > 0) return;

        data.sections.forEach(s => s.options.forEach((o) => {
            if (o.custom) {
                buySampleAllCustomOptionsTemp.push({
                    optionId: o.optionId,
                    sectionname: s.name,
                    textvalue: "",
                    selected: false
                })
            }

        }));
        setbuySampleAllCustomOptions(buySampleAllCustomOptionsTemp);        
    }


    const expandEditableTextChanged = (option, inputFieldValue) => {
        if (option.custom) {
            option.additionalInfo.row2 = inputFieldValue + " - " + option.fabricCollectionName;
        }
        else {
            option.additionalInfo.row2 = inputFieldValue;
        }

        ExpandOptionsValidationInit();

        var allCustomOptionsTemp = allCustomOptions;

        for (var i = 0; i < allCustomOptionsTemp.length; i++) {

            if (allCustomOptionsTemp[i].optionId == option.optionId) {
                allCustomOptionsTemp[i].textvalue = inputFieldValue;
            }
        }

        setallCustomOptions(allCustomOptionsTemp);        

        if (inputFieldValue != "" && inputFieldValue != undefined && inputFieldValue !== null) {
            select(option);
        }

    }
    const expandEditableTextChangedBuySamples = (option, inputFieldValue) => {
        option.additionalInfo.row2 = inputFieldValue;

        BuySamplesExpandOptionsValidationInit();

        var buySampleAllCustomOptionsTemp = buySampleAllCustomOptions;

        for (var i = 0; i < buySampleAllCustomOptionsTemp.length; i++) {

            if (buySampleAllCustomOptionsTemp[i].optionId == option.optionId) {
                buySampleAllCustomOptionsTemp[i].textvalue = inputFieldValue;
            }
        }
        setbuySampleAllCustomOptions(buySampleAllCustomOptionsTemp);
        
        if (inputFieldValue != "" && inputFieldValue != undefined && inputFieldValue !== null) {
            addSelectedOptions(option, "buysampleTextChanged");
        }
    }

    const ExpandOptionValidationCheckboxChanged = (section, option) => {
        ExpandOptionsValidationInit();

        var allCustomOptionsTemp = allCustomOptions;
        for (var i = 0; i < allCustomOptionsTemp.length; i++) {
            if (allCustomOptionsTemp[i].sectionname == section.name) {
                allCustomOptionsTemp[i].selected = false;
                if (allCustomOptionsTemp[i].optionId == option.optionId) {
                    allCustomOptionsTemp[i].selected = true;
                }
            }
        }
        setallCustomOptions(allCustomOptionsTemp);        
    }

    const BuySampleTextValidate = (option, selected) => {
        if (!option.custom) return;
        BuySamplesExpandOptionsValidationInit();

        var buySampleAllCustomOptionsTemp = buySampleAllCustomOptions;
        for (var i = 0; i < buySampleAllCustomOptionsTemp.length; i++) {
            if (buySampleAllCustomOptionsTemp[i].optionId == option.optionId) {
                buySampleAllCustomOptionsTemp[i].selected = selected;
            }
        }
        setbuySampleAllCustomOptions(buySampleAllCustomOptionsTemp);        
    }

    const getSelectedOrDefaultOptionKeyFromSection = (section) => {
        let key = '';
        section.options.forEach((option) => {
            if (option.selected) {
                key = option.key;
            }
        });

        if (key == '') {
            // get the default key if no option selected.
            key = section.options.length > 0 ? section.options[0].key : '';
        }

        return key;
    }

    const select = (option) => {        
        let section = getSectionFromOption(option),
            key = null, selectedCombineKeys = null, triggerArticles = null;

        section.options.forEach((o) => {
            if (o.selected && o.optionId != option.optionId) {
                key = o.key;
                o.selected = false;
            }
        });

        if (key == null) {
            // get the default key if no option selected.
            key = section.options.length > 0 ? section.options[0].key : '';
        }

        section.userSelected = true;
        option.selected = true;
        var selectedOptionsTemp = getSelectedOptions();

        if (option.key) {
            var currentState = data;
            currentState.selectedCombinedKeys = replaceOrAddConfigKey(option.key.replace(" ", ""), key);
            
            setdata(currentState);
            setselectedOptions(selectedOptionsTemp);      
            
            if (props.isSuperBuilderActive) {
                let updated = false;
                let keyNotFound = false;
                let tempSuperBuilderKeys = superBuilder.selectedCombinedSuperBuilderKeys;

                if (tempSuperBuilderKeys.some(x => x.value.some(y => y === key))) {
                    for (var x = 0; x < tempSuperBuilderKeys.length; x++) {
                        for (var y = 0; y < tempSuperBuilderKeys[x].value.length; y++) {
                            if (tempSuperBuilderKeys[x].value[y] === key) {
                                tempSuperBuilderKeys[x].value[y] = option.key.replace(" ", "");
                                updated = true;
                            }
                        }
                    }   
                }
                else {
                    for (var x = 0; x < tempSuperBuilderKeys.length; x++) {
                        tempSuperBuilderKeys[x].value.push(option.key.replace(" ", ""));
                    }
                    updated = true;
                }                                
                if (updated) {
                    dispatch(selectSuperBuilderVariant(tempSuperBuilderKeys));
                }            
            }
        }
        else {
            setselectedOptions(selectedOptionsTemp);
        }

        ExpandOptionValidationCheckboxChanged(section, option);

        if (data.triggerArticles.includes(option.articleNumber)) {
            fetch("/api/productConfigurator/selectarticle", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'litium-request-context': JSON.stringify(__litium.requestContext)
                },
                body: JSON.stringify({
                    "Model": data,
                    "Article": option.articleNumber,
                    "IsSuperBuilder": props.isSuperBuilderActive
                }),
                redirect: 'follow'
            })
                .then(response => response.json())
                .then(result => {
                    selectedCombineKeys = result.selectedCombinedKeys;
                    triggerArticles = result.triggerArticles;
                    result.sections.forEach(section => {
                        if (section.updated) {
                            showArticleInfo(null, null); // avoid rare error if info article is replaced

                            var existingData = data;
                            existingData.selectedCombinedKeys = selectedCombineKeys;
                            existingData.triggerArticles = triggerArticles;
                            var filteredSection = existingData.sections.filter(y => y.id == section.id);
                            if (filteredSection != null && filteredSection.length > 0) {
                                filteredSection[0].options = section.options;
                            }
                            existingData.sections.forEach(s => {
                                if (s.id === section.id) {
                                    s.userSelected = false;
                                    s.options = section.options;
                                }
                            });
                            setdata(existingData);
                            setselectedOptions(getSelectedOptions());                            
                        }
                    });
                })
                .then(() => {
                    refreshSelection();
                })
                .catch(error => console.log('error', error));
        }

        if (props.isSuperBuilderActive) {
            props.updatePrice(data.selectedCombinedKeys, true, false, selectedOptions);
        }

        if (selectedCombineKeys !== null && selectedCombineKeys !== undefined) {
            var tempData = data;
            tempData.selectedCombinedKeys = selectedCombineKeys;
            setdata(tempData);
            refreshSelection();
        }
        else {
            refreshSelection();
        }
        showArticleInfo(null);
    }

    const setAllSectionsNonSelected = (data) => {
        if (!data) {
            data = data;
        }

        data.sections.forEach(s => {
            s.userSelected = false;
        });

        return !data.sections.some(s => (!s.isAccessory && !s.userSelected && s.options.length > 0));
    }

    const refreshPrice = (data, priceData) => {
        let totalPrices = {
            price: 0,
            originalPrice: 0,
            grandTotal: 0
        };

        if (props.isSuperBuilderActive && data.selectedCombinedKeys && data.selectedCombinedKeys.length === 0) {
            setgrandTotal(0);
            setoriginalTotal(0);
            setconfiguratorTotal(0);            

            return;
        }

        totalPrices = getTotalPriceFromKeys(data.selectedCombinedKeys, priceData);

        let totals = {
            grandTotal: totalPrices.price * quantity,
            originalTotal: totalPrices.originalPrice * quantity,
            configTotal: totalPrices.price
        }

        data.sections.forEach(section => {
            if (section.isAccessory) {
                section.options.forEach(o => {
                    if (o.selected) {
                        let unitPrice = (o.campaignPrice > 0 && o.campaignPrice < o.price ? o.campaignPrice : o.price);
                        totals.grandTotal += (unitPrice * o.quantity);
                        totals.originalTotal += (unitPrice * o.quantity);
                    }
                });
            }
        });
        
        setgrandTotal(totals.grandTotal);
        setoriginalTotal(totals.originalTotal);
        setconfiguratorTotal(totals.configTotal);
    }

    const getTotalPriceFromKeys = (keys, priceData) => {
        let pricesTemp = prices;
        if (priceData && priceData.length > 0) {
            pricesTemp = priceData;
        }

        let totalPrices = {
            price: 0,
            originalPrice: 0,
            grandTotal: 0
        };

        var amountOfPricesToAdd = keys.length;
        var isSuperBuilderActive = props.isSuperBuilderActive;
        var index = 0;
        for (let i = 0; i < pricesTemp.length; i++) {
            let price = pricesTemp[i],
                test = { key: "", value: [], added: false, quantity: 0 },
                priceNotMatched = true;

            for (let y = 0; y < keys.length; y++) {
                priceNotMatched = true;
                if (!keys[y].added) {
                    priceNotMatched = true;

                    if (!Array.isArray(keys[y].value) && keys[y].value !== "") {
                        keys[y].value = [keys[y].value];
                    }

                    for (let u = 0; u < keys[y].value.length; u++) {
                        //priceNotMatched = !price.systemKeys.includes(keys[y].value[u]);

                        priceNotMatched = isSuperBuilderActive ? !(price.systemKeys.includes(keys[y].key) && price.systemKeys.includes(keys[y].value[u])) 
                        : !price.systemKeys.includes(keys[y].value[u]);
                        if (priceNotMatched) {
                            break;
                        }
                    }

                    if (priceNotMatched && isSuperBuilderActive && keys[y].value.length === 0) {                        
                        test = keys[y];                        
                        test.value = test.key;
                        break;
                    }

                    if (!priceNotMatched) {
                        test = keys[y];
                        break;
                    }                    
                }
            }

            if (isSuperBuilderActive && !test.added && test.value.length > 0 && amountOfPricesToAdd != index) {
                index++;
                test.added = true;
                let quantity = test.quantity > 0 ? test.quantity : 1;
                totalPrices.price += price.totalPrice * quantity;
                totalPrices.originalPrice += price.originalPrice * quantity;                
                if (amountOfPricesToAdd == index) {
                    break;
                }
            }
            else if (!isSuperBuilderActive && test.value.length > 0) {
                totalPrices.price = price.totalPrice;
                totalPrices.originalPrice = price.originalPrice;
                break;
            }
        }

        resetAdded(keys);

        return totalPrices;
    }

    const resetAdded = (selectedKeys) => {
        if (selectedKeys.length != undefined) {
            selectedKeys.forEach((key) => key.added = false);
        }
        else {
            selectedKeys.added = true;
        }
    }

    const refreshSelection = () => {
        let sectionsSelectedTemp = !data.sections.some(s => (!s.isAccessory && !s.userSelected && s.options.length > 0));
        let totals = getGrandTotal();
        setgrandTotal(totals.grandTotal);
        setoriginalTotal(totals.originalTotal);
        setconfiguratorTotal(totals.configTotal);

        setsectionsSelected(sectionsSelectedTemp);
        setaccessorySelected(anyAccessorySelected());
        settotalsData(totals);                

        if (!props.isSuperBuilderActive) {
            var stockStatusConfigurator = sectionsSelectedTemp ? getStockStatus() : undefined;

            setstockstatus(sectionsSelectedTemp ? (stockStatusConfigurator != undefined ? stockStatusConfigurator : stockstatus) : stockstatus);            
        }

        setTimeout(
            function () {
                refreshKlarnaWidget();
            }
                .bind(this),
            100
        );
    }

    const getSelectedOptions = (dataInput, changeVariant) => {
        if (changeVariant) {
            let tempSelectedOptionsName = [];

            return tempSelectedOptionsName;
        }

        if (!dataInput || dataInput == null) {
            dataInput = data;
        }

        let selectedOptions = dataInput.sections.filter((x) => !x.isAccessory);
        let selectedOptionsName = selectedOptions.flatMap(x => x.options.filter(o => o.selected)).map(x => getSelectedOptionName(x));


        return selectedOptionsName;
    }

    const getSelectedOptionName = (option) => {
        if (option) {
            var name = option.name;

            if (option.categoryAdditionalHeader) {
                name = `${option.categoryAdditionalHeader} - ${name}`;
            }

            if (option.additionalInfo && option.additionalInfo.row2) {
                return `${name} -  ${option.additionalInfo.row2}`;
            }
            else {
                return name;
            }
        }
    }

    const selectVariant = (url) => {
        window.location = url;
    }

    const updateQuantity = (articleNumber, adjust) => {
        let newQuantity = quantity + adjust;

        if (newQuantity < 1) {
            newQuantity = props.packagingQuantity;
        }

        setquantity(newQuantity);

        if (props.isSuperBuilderActive) {
            props.updatePrice(null, false, false, null, newQuantity, null, true);
        }

        refreshSelection();
    }

    const showArticleInfo = (option, section) => {
        setinfoArticle(option);
        setinfoSection(section);        
    }

    const showOptionsOverlay = () => {
        setshowOptionsData(true);        
    }

    const getInfoArticle = () => {
        if (!infoArticle) {
            return null;
        }
        let sections = data.sections.filter(val => val.options.length > 0);
        return sections[infoArticle.sectionIndex].options[infoArticle.optionIndex];
    }

    const getInfoSection = () => {
        if (!infoSection) {
            return null;
        }

        return infoSection;
    }

    const traverseArticles = (steps) => {
        let section = data.sections.find(section => section.id === infoSection.id);
        let optionIndex = infoArticle.index;

        optionIndex += steps;

        if (optionIndex < 0) {
            optionIndex = (section.options.length - 1);
        } else if (optionIndex >= section.options.length) {
            optionIndex = 0;
        }
        let option = section.options[optionIndex];

        showArticleInfo(option, section);
    }

    const updateAccessoryQuantity = (articleNumber, quantityChange) => {
        data.sections.forEach(section => {
            if (section.isAccessory) {
                section.options.forEach(o => {
                    if (o.articleNumber === articleNumber) {
                        let newQuantity = o.quantity += quantityChange;

                        if (newQuantity < 0) {
                            newQuantity = 0;
                        }

                        o.selected = (newQuantity > 0);
                        o.quantity = newQuantity;
                    }
                });
            }
        });

        refreshSelection();
    }

    const toggleAccessory = (articleNumber, isChecked) => {
        data.sections.forEach(section => {
            if (section.isAccessory) {
                section.options.forEach(o => {
                    if (o.articleNumber === articleNumber) {
                        if (isChecked && o.quantity === 0) {
                            o.quantity = 1;
                        }

                        o.selected = isChecked;

                    }
                });
            }
        });

        refreshSelection();
    }

    const anyAccessorySelected = () => {
        let anySelected = false;

        data.sections.forEach(section => {
            if (section.isAccessory) {
                section.options.forEach(o => {
                    if (o.selected) {
                        anySelected = true;
                    }
                });
            }
        });

        return anySelected;
    }

    const HasValidTexts = (allCustomOptions) => {
        if (allCustomOptions == undefined) return true;
        for (var i = 0; i < allCustomOptions.length; i++) {
            var currentOption = allCustomOptions[i];
            if (currentOption.selected) {
                if (currentOption.textvalue == null || currentOption.textvalue == "" || currentOption.textvalue == undefined) return false;
            }
        }
        return true;
    }

    const showOptions = (allCustomOptions) => {
        return HasValidTexts(allCustomOptions) && sectionsSelected;
    }

    const toggleOptions = (show) => {
        setshowOptionsData(show);
        setshowData(false);  
        setloadConfiguratorOptions(!loadConfiguratorOptions);

        if (show) {
            if (!document.body.classList.contains('lock-scroll')) {
                document.body.classList.add('lock-scroll');
            }
        }
        else {
            if (document.body.classList.contains('lock-scroll')) {
                document.body.classList.remove('lock-scroll');                
            }
            const buyButtonElement = document.getElementsByClassName('buy-box__controls');
            if (buyButtonElement) {
                buyButtonElement[0].scrollIntoView({ behavior: "smooth", block: 'end', inline: 'nearest' });
            }

            var buyContainer = document.getElementsByClassName("buy-box__main");
            var productSelector = document.getElementsByClassName("product-selector__selected-options");
            if (buyContainer.length) { 
                if (buyContainer[0].classList.contains("anim-hide")) {
                    productSelector[0].scrollIntoView({ behavior: "smooth", block: 'end', inline: 'nearest' });
                    buyContainer[0].classList.remove("anim-hide"); 
                }                                              
            }
        }
    }

    const toggleBuySample = (value) => {
        setshowBuySample(value);
        setshowSuccess(false);
        setbuySampleViewAll(false);
        setbuySampleErrorFields([]);        
    }

    const addSelectedOptions = (option, eventSource = "") => {
        if (buySampleList != undefined && option != undefined) {
            var currentData = buySampleList;
            var dataIndex = currentData.indexOf(option.optionId)
            if (dataIndex >= 0) {
                if (eventSource != "buysampleTextChanged") {
                    currentData.splice(dataIndex, 1);
                    BuySampleTextValidate(option, false);
                    if (currentData.length <= 5) {
                        setshowError(false);                        
                    }
                }
            }
            else {
                if (currentData.length < 5) {
                    currentData.push(option.optionId);
                    BuySampleTextValidate(option, true);
                } else {
                    setshowError(option);                    
                }
            }
            setbuySampleList(currentData);  
            setupdateBuySamples(!updateBuySamples);

            if (buySampleList.length > 0) {
                var currentErrorFields = buySampleErrorFields;
                var removeIndex = buySampleErrorFields.indexOf("Fabrics");
                currentErrorFields.splice(removeIndex, 1);
                setbuySampleErrorFields(currentErrorFields);                
            }
        }
    }



    const toggleBuySampleViewAll = (value) => {
        setbuySampleViewAll(!value);        
    }

    const handleChange = (event) => {
        var currentValue = buySampleData;
        currentValue[event.target.name] = event.target.value;
        setbuySampleData(currentValue);        
    }

    const GetSelectedBuySampleData = () => {        
        var resultList = [];
        var allOptions = []

        data.sections.forEach(s => s.options.forEach((o) => {
            allOptions.push(o);
        }));

        for (var i = 0; i < buySampleList.length; i++) {
            var optionId = buySampleList[i];
            for (var j = 0; j < allOptions.length; j++) {
                var option = allOptions[j];
                if (option.optionId == optionId) {

                    if (option.custom) {
                        resultList.push((option.customName ? option.customName : option.name) + "-" + option.additionalInfo.row2);

                    } else {
                        resultList.push(option.additionalInfo ? option.additionalInfo.row2 : option.name)
                    }
                }
            }

        }
        return resultList;

    }

    const submitBuySample = () => {

        fetch("/api/productConfigurator/sendfabricsampleorder", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify({
                "FormData": buySampleData,
                "BuySampleData": GetSelectedBuySampleData(),
                "Brand": data.brand
            }),
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                if (result != null) {
                    if (result.errors != null) {
                        setbuySampleErrorFields(result.errors);                        

                        if (result.errors != undefined && result.errors.indexOf("Fabrics") >= 0) {
                            var element = document.getElementById("dvNoFabricSelected");
                            if (element != null) {
                                element.scrollIntoView();
                            }
                        }
                    }
                    else {
                        setshowSuccess(true);
                        setbuySampleList([]);                        
                    }
                }
            })
            .catch(error => console.log('error', error));
    }

    const refreshKlarnaWidget = () => {
        // Refresh Klarna widget
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

    const toggleFabricCollectionSectionVisibility = (Items) => {
        var fabricCollectionItems = fabricCollectionViewAll;
        Items.map((item) => {
            if (fabricCollectionItems.indexOf(a => a.Name === item.fabricCollectionName) === -1) {
                fabricCollectionItems.push({
                    Name: item.fabricCollectionName,
                    ViewAll: false,
                });
            }
        });
        setfabricCollectionViewAll(fabricCollectionItems);        
    }

    const toggleBuySampleFabricCollectionVisibility = (Items) => {
        var fabricCollectionItems = showBuySamplesFabricCollectionItems;
        Items.map((item) => {
            if (fabricCollectionItems.indexOf(a => a.Name === item.fabricCollectionName) === -1) {
                fabricCollectionItems.push({
                    Name: item.fabricCollectionName,
                    ViewAll: false,
                });
            }
        });
        setshowBuySamplesFabricCollectionItems(fabricCollectionItems);        
    }

    const setFabricCollectionVisibility = (collectionName, viewAll) => {
        var fabricCollectionItems = fabricCollectionViewAll;
        fabricCollectionItems.filter(a => a.Name === collectionName).forEach(a => a.ViewAll = !viewAll);
        setfabricCollectionViewAll(fabricCollectionItems);        
    }

    const setBuySampleFabricCollectionVisibility = (collectionName, viewAll) => {
        var fabricCollectionItems = showBuySamplesFabricCollectionItems;
        fabricCollectionItems.filter(a => a.Name === collectionName).forEach(a => a.ViewAll = !viewAll);
        setshowBuySamplesFabricCollectionItems(fabricCollectionItems);        
    }
    const getConfiguratorTranslation = () => {
        let websiteString = sectionsSelected ? 'configurator.selection.header' : 'configurator.selection.start.header';
        if (props.isSuperBuilderActive) {
            websiteString = sectionsSelected ? 'configurator.selection.header' : 'superbuilder.selection.start.header';
        }
        return websiteString;
    }

        return (
            <Fragment>
                <ul className={`product-selector ${props.isSuperBuilderActive ? superBuilder.mandatorySectionsValid ? '' : 'product-selector--disabled' : ''}`}>
                    <li className="product-selector__container">
                        <a className="product-selector__header" onClick={() => toggleOptions(true)}>
                            {showOptions(allCustomOptions) ?
                                <div className={'section-status section-status--done'}>
                                    <svg>
                                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                    </svg>
                                </div>
                                :
                                <div className={'section-status'}>
                                    <svg>
                                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#adjust"></use>
                                    </svg>
                                </div>
                            }
                            <div className="product-selector__name">
                                <span>
                                    {translate(getConfiguratorTranslation())}
                                </span>
                                <svg>
                                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
                                </svg>
                            </div>
                        </a>
                        {showOptions(allCustomOptions) && selectedOptions && selectedOptions.length > 0 && <div className="product-selector__selected-options">
                            <ol className="product-selector__selected-options-list">
                                {selectedOptions.map((selectedOption, index) => {
                                    return <li key={index} className="product-selector__selected-option">
                                        {selectedOption}
                                    </li>
                                })}
                            </ol>
                        </div>
                        }
                    </li>
                    {data.sections != undefined && data.sections.some(s => s.isAccessory) &&
                        <li>
                            <div className="product-selector__header">
                                {showOptions(allCustomOptions) && accessorySelected ?
                                    <div className={'section-status section-status--done'}>
                                        <svg>
                                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                        </svg>
                                    </div>
                                    :
                                    <div className={'section-status'}>
                                        <svg>
                                            <use href=""></use>
                                        </svg>
                                    </div>
                                }
                                <div className="product-selector__name">
                                    <span>{translate('configurator.recommended.header')}</span>
                                </div>
                            </div>
                            <div className="product-selector__content">
                                <ul className="accessory-list">
                                    {data.sections.filter(s => s.isAccessory).map((section) => {
                                        return section.options.map((option) => {
                                            return <li key={`option-${option.id}`}>
                                                <div className={'image-container contain' + (option.imageData && option.imageData.thumbnail ? '' : ' dummy-image')}>
                                                    {option.imageData.src && <a data-src={option.imageData.src} itemProp="url" className="product-image" onClick={() => onAccessoryClick(option.imageData)}>                                                        
                                                        <img className="product-detail__image--main" itemProp="image" src={option.imageData.thumbnail} 
                                                        alt={option.imageData.alt}/>
                                                    </a>
                                                    }
                                                </div>
                                                <div className="accessory-list__content">
                                                    <Checkbox isChecked={option.selected} onClick={toggleAccessory} isSmall={true} value={option.articleNumber}></Checkbox>
                                                    <div className="accessory-list__content-container">
                                                        <div className="accessory-list__name">
                                                            <span>{option.name}</span>
                                                        </div>
                                                        <ProductPrice
                                                            formatter={formatter}
                                                            campaignPrice={option.campaignPrice}
                                                            price={option.price}
                                                            packagingQuantity={option.packagingQuantity}
                                                            quantity={option.quantity}
                                                        ></ProductPrice>
                                                        <QuantitySelector isSmall={true} quantity={option.quantity} articleNumber={option.articleNumber} packagingQuantity={option.packagingQuantity} 
                                                        onChange={updateAccessoryQuantity}></QuantitySelector>
                                                    </div>
                                                </div>
                                            </li>
                                        })
                                    })}
                                </ul>
                            </div>
                        </li>
                    }
                </ul>
                <BuyBox buy={buy}
                    totalPrice={grandTotal}
                    quantity={quantity}
                    articleNumber={'n/a'}
                    currentPrice={''}
                    originalPrice={originalTotal}
                    updateQuantity={updateQuantity}
                    packagingQuantity={props.packagingQuantity}
                    comment={props.comment}
                    stockInfoMessage={props.stockInfoMessage}
                    formatter={formatter}
                    stockstatus={stockstatus}
                    enabled={showOptions(allCustomOptions)}
                    toggleOptions={showOptionsOverlay}
                    featureList={props.featureList}                    
                    productInfoMessage={props.productInfoMessage}
                    isSuperBuilderActive={props.isSuperBuilderActive}
                    scroll={scrollToSuperBuilder}
                >
                </BuyBox>
                {activeAccessory &&
                    <LightboxImagesAccessories images={activeAccessory} onClick={() => onAccessoryClick()} />
                }

                {showOptionsData &&
                    <div className="configurator-options__close-outside" onClick={() => toggleOptions(false)} ></div>
                }
                <div className={getOptionsCssClass()}>
                    <ConfiguratorOptions
                        formatter={formatter}
                        data={data}
                        toggleOptions={toggleOptions}
                        infoArticle={infoArticle}
                        getPriceChange={getPriceChange}
                        grandTotal={configuratorTotal ? configuratorTotal : grandTotal}
                        select={select}
                        showArticleInfo={showArticleInfo}
                        allDone={showOptions(allCustomOptions)}
                        showMoreButton={showMoreButton}
                        originalPrice={originalTotal}
                        toggleBuySample={toggleBuySample}
                        setFabricCollectionVisibility={setFabricCollectionVisibility}
                        fabricCollectionViewAll={fabricCollectionViewAll}
                        maximumNumberOfItemsInCollection={maximumNumberOfItemsInCollection}
                        maximumNumberOfItemsInSection={maximumNumberOfItemsInSection}
                        quantity={quantity ? quantity : 1}
                        customFieldErrors={null}
                        expandEditableTextChanged={expandEditableTextChanged}
                        allCustomOptions={allCustomOptions}
                        loadConfiguratorOptions={loadConfiguratorOptions}                     
                        >
                    </ConfiguratorOptions>

                    <ConfiguratorOptionInfo
                        infoArticle={infoArticle}
                        infoSection={getInfoSection()}
                        showArticleInfo={showArticleInfo}
                        select={select}
                        traverseArticles={traverseArticles}>
                    </ConfiguratorOptionInfo>

                    <ConfiguratorBuySamples
                        dataInfo={data.sections != undefined && data.sections.filter(a => a.options.filter(x => x.additionalInfo != null).length > 0)}
                        showData={showBuySample}
                        toggleBuySample={toggleBuySample}
                        showArticleInfo={showArticleInfo}
                        buySampleList={buySampleList}
                        addSelectedOptions={addSelectedOptions}
                        removeSelectedOptions={null}
                        buySampleViewAll={buySampleViewAll}
                        toggleBuySampleViewAll={toggleBuySampleViewAll}
                        submitBuySample={submitBuySample}
                        buySampleData={buySampleData}
                        handleChange={handleChange}
                        buySampleErrorFields={buySampleErrorFields}
                        showError={showError}
                        showSuccess={showSuccess}
                        maximumNumberOfItemsInCollection={maximumNumberOfItemsInCollection}
                        maximumNumberOfItemsInSection={maximumNumberOfItemsInSection}
                        showBuySamplesFabricCollectionItems={showBuySamplesFabricCollectionItems}
                        setBuySampleFabricCollectionVisibility={setBuySampleFabricCollectionVisibility}
                        buySampleAllCustomOptions={buySampleAllCustomOptions}
                        expandEditableTextChangedBuySamples={expandEditableTextChangedBuySamples}
                        key={updateBuySamples}
                    >
                    </ConfiguratorBuySamples>
                </div>
            </Fragment>
        );    
}

export default Configurator;
